import type { BuilderCampaignSnapshot, ChannelConfig, StepCompletion } from "campaign-builder/config/channelConfig";
import { registerChannelConfig } from "campaign-builder/config/channelRegistry";
import { getFormatsFor } from "campaign-builder/formats";
import { validateCampaignName } from "campaign-builder/state";
import { D2dTargetingStep } from "campaign-builder/channels/flyering/targeting";
import { flyeringLastActiveStep } from "../h2h/h2h.config";

export interface D2dBuilderSnapshot extends BuilderCampaignSnapshot {
  lettersAmount?: number;
  hasDesign?: boolean;
  trackingValid?: boolean;
}

// Targeting gates on a valid campaign name and a chosen launch date (F2). The
// minimum distribution-area gate is added by F8. Design gates on a selected design
// (F10); Tracking gates on the static-only form's validity (F11).
const getD2dStepCompletion = (campaign: BuilderCampaignSnapshot): StepCompletion => ({
  targeting: validateCampaignName(campaign.campaignName ?? "") === null && !!campaign.startDate,
  design: !!(campaign as D2dBuilderSnapshot).hasDesign,
  tracking: !!(campaign as D2dBuilderSnapshot).trackingValid,
});

export const d2dChannelConfig: ChannelConfig = {
  channel: "D2D",
  label: "Door-to-Door",
  TargetingStep: D2dTargetingStep,
  summaryUnits: {
    label: "Letterboxes",
    getValue: (campaign) => (campaign as D2dBuilderSnapshot).lettersAmount ?? 0,
  },
  getFormats: (countryCode) => getFormatsFor("D2D", countryCode),
  design: {
    addressBoxRequired: false,
    maxFileSizeMb: 50,
    acceptedFileTypes: ["application/pdf"],
    showFormatSelector: true,
    formatDisclaimerChannel: "Door to Door",
  },
  tracking: { promoCodes: true, qrCodes: true, placeholders: false },
  orderDetails: { quoteItemLabel: "Door to Door" },
  getStepCompletion: getD2dStepCompletion,
  // Shares the flyering cursor vocab with H2H (see h2h.tsx).
  lastActiveStep: flyeringLastActiveStep,
};

registerChannelConfig(d2dChannelConfig);
